import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import { Link } from "react-router";

/**
 * An unknown address.
 *
 * It says nothing about whether the address would have existed for somebody
 * else, because that would turn the router into an inventory of screens the
 * viewer is not meant to know about.
 */
export function NotFoundScreen() {
  return (
    <div className="max-w-2xl">
      <span aria-hidden="true" className="grid size-14 place-items-center rounded-full bg-surface-raised shadow-panel">
        <MagnifyingGlassIcon className="size-7 text-text-muted" weight="duotone" />
      </span>
      <h1 className="mt-6 text-4xl font-extrabold tracking-tight">This address is not part of BurgePOS</h1>
      <p className="mt-3 leading-7 text-text-muted">
        Check the address, or start again from the workspace entry point.
      </p>
      <Link
        className="mt-7 inline-flex min-h-12 items-center rounded-full bg-accent px-5 text-sm font-bold text-on-accent hover:bg-accent-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
        to="/"
      >
        Go to the workspace
      </Link>
    </div>
  );
}
